import React, { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import {
    Grid,
    Drawer,
    Divider,
    IconButton,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    Typography,
    ListItemButton,
    Tooltip,
} from "@mui/material";

import { useTheme } from "@mui/material/styles";
import { useDispatch, useStore } from "react-redux";
import { logout } from "../../actions/oauthActions";
import ApplicationsMenu from "./ApplicationsMenu";
import style from "./style";
import { useHistory } from "react-router";
import Gravatar from "react-gravatar";

import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import AppsOutlinedIcon from "@mui/icons-material/AppsOutlined";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import HelpOutlineOutlinedIcon from "@mui/icons-material/HelpOutlineOutlined";
import ExitToAppOutlinedIcon from "@mui/icons-material/ExitToAppOutlined";

function Menu({ open, handleClose }) {
    const classes = style();
    const theme = useTheme();
    const store = useStore();
    const homeRef = useRef(null);
    useEffect(() => {
        if (open) {
            homeRef.current.focus();
        }
    }, [open]);
    const user = store.getState().user || {};

    const secondMenu = [
        {
            path: "/subscriptions",
            label: "Subscriptions",
            icon: <AppsOutlinedIcon />,
        },
        {
            path: "/settings",
            label: "Settings",
            icon: <SettingsOutlinedIcon />,
        },
        { path: "/help", label: "Help", icon: <HelpOutlineOutlinedIcon /> },
    ];

    const dispatch = useDispatch();
    const history = useHistory();
    const handleSignOut = () => {
        logout(dispatch);
        history.replace("/");
    };

    return (
        <Drawer
            className={classes.drawer}
            variant="persistent"
            anchor="left"
            open={open}
            classes={{
                paper: classes.drawerPaper,
            }}
        >
            <Grid container spacing={0} className={classes.drawerHeader}>
                <Grid container spacing={1}>
                    <Grid item xs={10} sm={10} md={10}>
                        <Gravatar
                            email={user.email}
                            default="https://cdn.premierit.com/images/icons/contact.png"
                            size={50}
                            style={{ borderRadius: "50%" }}
                        />
                    </Grid>
                    <Grid item xs={2} sm={2} md={2}>
                        <Tooltip title="close navigation menu" arrow>
                            <IconButton
                                onClick={handleClose}
                                sx={{ color: "background.paper" }}
                                aria-label="close"
                            >
                                {theme.direction === "ltr" ? (
                                    <ChevronLeftIcon />
                                ) : (
                                    <ChevronRightIcon />
                                )}
                            </IconButton>
                        </Tooltip>
                    </Grid>
                </Grid>
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={12} md={12}>
                        <Link to="/profile">
                            <Typography
                                variant="h3"
                                component="div"
                                className={classes.drawerLink}
                            >
                                {user.name}
                            </Typography>
                            <Typography
                                variant="p"
                                component="div"
                                className={classes.drawerLink}
                            >
                                {user.email}
                            </Typography>
                        </Link>
                    </Grid>
                </Grid>
            </Grid>
            <Divider />
            <List
                className="menu-list"
                component="nav"
                aria-label="Main menu"
                data-cy="menu_main"
            >
                <ListItem component={Link} to="/" ref={homeRef} disablePadding>
                    <ListItemButton>
                        <ListItemIcon>
                            <HomeOutlinedIcon />
                        </ListItemIcon>
                        <ListItemText>Home</ListItemText>
                    </ListItemButton>
                </ListItem>
            </List>
            <ApplicationsMenu />
            <List
                className="menu-list-last"
                component="nav"
                aria-label="System menu"
                data-cy="menu_system"
            >
                {secondMenu &&
                    secondMenu.length &&
                    secondMenu.map(({ path, icon, label }) => (
                        <ListItem
                            key={path}
                            component={Link}
                            to={path}
                            disablePadding
                        >
                            <ListItemButton>
                                <ListItemIcon>{icon}</ListItemIcon>
                                <ListItemText>{label}</ListItemText>
                            </ListItemButton>
                        </ListItem>
                    ))}
                <ListItem key="Sign Out" onClick={handleSignOut} disablePadding>
                    <ListItemButton>
                        <ListItemIcon>
                            <ExitToAppOutlinedIcon />
                        </ListItemIcon>
                        <ListItemText primary="Sign Out" />
                    </ListItemButton>
                </ListItem>
            </List>
        </Drawer>
    );
}

export default Menu;
